<template>
  <div>
    <FormComponent
      @searchForm="getFormData"
      :searchFormItem="formItem"
      :labelWidth="100"
      ref="FormComponent"
      @handleReset="handleReset"
    >
      <Col :xs="24" :sm="24" :md="12" :lg="6" slot="slot1">
        <FormItem :label="$t('Version')"
          ><!-- 版本 -->
          <Input v-model="formItem.version" clearable />
        </FormItem>
      </Col>
      <Col :xs="24" :sm="24" :md="12" :lg="6" slot="slot2">
        <FormItem :label="$t('Status')"
          ><!-- 状态 -->
          <Select v-model="formItem.status" clearable>
            <Option
              v-for="item in ApplyStatus"
              :value="item.code"
              :key="item.code"
              >{{ lang == "zh" ? item.ch_value : item.en_value }}</Option
            >
          </Select>
        </FormItem>
      </Col>
      <Col
        :xs="24"
        :sm="24"
        :md="12"
        :lg="6"
        slot="slot3"
      >
        <FormItem :label="$t('Management_Level')"
          ><!-- 管理层级 -->
          <Select v-model="formItem.hrmanage" clearable>
            <Option
              v-for="item in ManagementLevel"
              :value="item.code"
              :key="item.code"
              >{{ lang == "zh" ? item.ch_value : item.en_value }}</Option
            >
          </Select>
        </FormItem>
      </Col>
    </FormComponent>
    <Table
      border
      :loading="loading"
      :columns="columns"
      :data="data"
      style="margin:20px 0"
    >
      <template slot-scope="{ row, index }" slot="action">
        <Button
          type="primary"
          icon="md-reorder"
          size="small"
          @click="checkBtn(row, index)"
        ></Button>
      </template>
    </Table>
    <Table
      border
      :loading="loading"
      :columns="columnsA"
      :data="data1"
      style="margin:20px 0"
      v-show="false"
      ref="tableRef"
    >
      <template slot-scope="{ row, index }" slot="action">
        <Button
          type="primary"
          icon="md-reorder"
          size="small"
          @click="checkBtn(row, index)"
        ></Button>
      </template>
    </Table>
    <div style="margin:20px 0;display:flex;justify-content: space-between;">
      <div>
        <Button type="primary" @click="batchApproval"
          ><!-- 审批 -->{{ $t("ToDoList") }}</Button
        >
        <Button type="primary" @click="noSubmitEmp"
          ><!-- 未提交员工名单 -->{{
            $t("Employee_list_not_submitted")
          }}</Button
        >
      </div>
      <div
        style="margin:20px 0;display:flex; justify-content: flex-end;flex-direction: column; align-items: flex-end;"
      >
        <Page
          :total="total"
          :current="pageInfo.pageNo"
          :page-size="pageInfo.pageSize"
          transfer
          @on-change="pageChange"
          :page-size-opts="[10, 50, 100, 150]"
          show-sizer
          @on-page-size-change="pageSizeChange"
        />
        <Button type="primary" style="margin-top:15px" @click="exportData()"
          ><!-- 导出 -->{{ $t("PB_Export") }}</Button
        >
      </div>
    </div>
    <BatchApprovalModalComponent
      ref="BatchApprovalModalComponent"
    ></BatchApprovalModalComponent>
    <NoSubmitEmp
      ref="NoSubmitEmp"
      :departmentList="departmentList"
      :businessUnitList="businessUnitList"
    ></NoSubmitEmp>
  </div>
</template>

<script>
import FormComponent from "./FormComponent.vue";
import BatchApprovalModalComponent from "./modalComponents/BatchApprovalModalComponent.vue";
import NoSubmitEmp from "./modalComponents/NoSubmitEmp.vue";
import axios from "axios";
import DateUtil from "../../../../util/DateUtil";
export default {
  components: { FormComponent, BatchApprovalModalComponent, NoSubmitEmp },
  data() {
    return {
      date: new DateUtil(),
      formItem: {
        dirSupUserName: ""
      },
      searchItem: {},
      selectList: [],
      updateStatus: [],
      ApplyStatus: [], //状态
      loading: false,
      pageInfo: {
        itemCount: 0,
        pageNo: 1,
        pageSize: 10
      },
      total: 0,
      data1: [],
      data: [],
      Level: [],
      positionList: [],
      departmentList: [],
      businessUnitList: [],
      ManagementLevel: []
    };
  },
  computed: {
    columns() {
      return [
        {
          title: this.$t("Check") /* 查看 */,
          slot: "action",
          align: "center",
          minWidth: 120,
          fixed: "left"
        },
        {
          title: this.$t("Name") /* 姓名 */,
          key: "userName",
          align: "center",
          minWidth: 120,
          fixed: "left"
        },
        {
          title: this.$t("English_Name") /* 英文名 */,
          key: "userEName",
          align: "center",
          minWidth: 120
        },
        {
          title: this.$t("Employee_Code") /* 员工号 */,
          key: "empCode",
          align: "center",
          minWidth: 120
        },
        {
          title: this.$t("BU") /* 业务单元 */,
          key: "businessUnit",
          align: "center",
          minWidth: 120,
          render: (h, params) => {
            return h(
              "span",
              this.businessUnitList &&
                this.businessUnitList
                  .filter(item => params.row.businessUnit == item.code)
                  .map(res => (this.lang == "zh" ? res.ch_value : res.en_value))
            );
          }
        },
        {
          title: this.$t("Position_Name_Chinese") /* 职位 */,
          key: "position",
          align: "center",
          minWidth: 120
          // render: (h, params) => {
          //     return h(
          //     "span",
          //     this.positionList &&
          //         this.positionList.filter(
          //         item => params.row.position == item.code
          //         ).map(res => (this.lang=='zh'?res.ch_value:res.en_value))
          //     );
          // }
        },
        {
          title: this.$t("Position_Name_English") /* 职位 */,
          key: "enPosition",
          align: "center",
          minWidth: 120
        },
        {
          title: this.$t("Department") /* 部门 */,
          key: "department",
          align: "center",
          minWidth: 120,
          render: (h, params) => {
            return h(
              "span",
              this.departmentList &&
                this.departmentList
                  .filter(item => params.row.department == item.code)
                  .map(res => (this.lang == "zh" ? res.ch_value : res.en_value))
            );
          }
        },
        {
          title: this.$t("Year") /* 年度 */,
          key: "year",
          align: "center",
          minWidth: 120
        },
        {
          title: this.$t("Line_Manager") /* 直线上级 */,
          key: this.lang == "zh" ? "dirSupUserName" : "dirSupUserEName",
          align: "center",
          minWidth: 120
        },
        {
          title: this.$t("Version") /* 版本 */,
          key: "version",
          align: "center",
          minWidth: 120
        },

        {
          title: this.$t("Is_Update") /* 是否修订 */,
          key: "updateStatusName",
          align: "center",
          minWidth: 120,
          render: (h, params) => {
            return h(
              "span",
              this.updateStatus &&
                this.updateStatus
                  .filter(item => params.row.updateStatusName == item.code)
                  .map(res => (this.lang == "zh" ? res.ch_value : res.en_value))
            );
          }
        },
        {
          title: this.$t("update_approver") /* 当前修订确认人 */,
          key:
            this.lang == "zh"
              ? "updateApprovalUserName"
              : "updateApprovalUserEName",
          align: "center",
          minWidth: 120
        },
        {
          title: this.$t("Status") /* 状态 */,
          key: "status",
          align: "center",
          minWidth: 120,
          render: (h, params) => {
            return h(
              "span",
              this.ApplyStatus &&
                this.ApplyStatus.filter(
                  item => params.row.status == item.code
                ).map(res => (this.lang == "zh" ? res.ch_value : res.en_value))
            );
          }
        },
        {
          title: this.$t("Current_Approver") /* 当前设定确认人 */,
          key: this.lang == "zh" ? "approvalUserName" : "approvalUserEName",
          align: "center",
          minWidth: 120
        }
      ];
    },
    columnsA() {
      return [
        {
          title: this.$t("Check") /* 查看 */,
          slot: "action",
          align: "center",
          minWidth: 120,
          fixed: "left"
        },
        {
          title: this.$t("Name") /* 姓名 */,
          key: "userName",
          align: "center",
          minWidth: 120,
          fixed: "left"
        },
        {
          title: this.$t("English_Name") /* 英文名 */,
          key: "userEName",
          align: "center",
          minWidth: 120
        },
        {
          title: this.$t("Employee_Code") /* 员工号 */,
          key: "empCode",
          align: "center",
          minWidth: 120
        },
        {
          title: this.$t("BU") /* 业务单元 */,
          key: "businessUnit",
          align: "center",
          minWidth: 120,
          render: (h, params) => {
            return h(
              "span",
              this.businessUnitList &&
                this.businessUnitList
                  .filter(item => params.row.businessUnit == item.code)
                  .map(res => (this.lang == "zh" ? res.ch_value : res.en_value))
            );
          }
        },
        {
          title: this.$t("Position_Name_Chinese") /* 职位 */,
          key: "position",
          align: "center",
          minWidth: 120
          // render: (h, params) => {
          //     return h(
          //     "span",
          //     this.positionList &&
          //         this.positionList.filter(
          //         item => params.row.position == item.code
          //         ).map(res => (this.lang=='zh'?res.ch_value:res.en_value))
          //     );
          // }
        },
        {
          title: this.$t("Position_Name_English") /* 职位 */,
          key: "enPosition",
          align: "center",
          minWidth: 120
        },
        {
          title: this.$t("Department") /* 部门 */,
          key: "department",
          align: "center",
          minWidth: 120,
          render: (h, params) => {
            return h(
              "span",
              this.departmentList &&
                this.departmentList
                  .filter(item => params.row.department == item.code)
                  .map(res => (this.lang == "zh" ? res.ch_value : res.en_value))
            );
          }
        },
        {
          title: this.$t("Year") /* 年度 */,
          key: "year",
          align: "center",
          minWidth: 120
        },
        {
          title: this.$t("Line_Manager") /* 直线上级 */,
          key: this.lang == "zh" ? "dirSupUserName" : "dirSupUserEName",
          align: "center",
          minWidth: 120
        },
        {
          title: this.$t("Version") /* 版本 */,
          key: "version",
          align: "center",
          minWidth: 120
        },
        {
          title: this.$t("Is_Update") /* 是否修订 */,
          key: "updateStatusName",
          align: "center",
          minWidth: 120,
          render: (h, params) => {
            return h(
              "span",
              this.updateStatus &&
                this.updateStatus
                  .filter(item => params.row.updateStatusName == item.code)
                  .map(res => (this.lang == "zh" ? res.ch_value : res.en_value))
            );
          }
        },
        {
          title: this.$t("update_approver") /* 当前修订确认人 */,
          key:
            this.lang == "zh"
              ? "updateApprovalUserName"
              : "updateApprovalUserEName",
          align: "center",
          minWidth: 120
        },
        {
          title: this.$t("Status") /* 状态 */,
          key: "status",
          align: "center",
          minWidth: 120,
          render: (h, params) => {
            return h(
              "span",
              this.ApplyStatus &&
                this.ApplyStatus.filter(
                  item => params.row.status == item.code
                ).map(res => (this.lang == "zh" ? res.ch_value : res.en_value))
            );
          }
        },
        {
          title: this.$t("Current_Approver") /* 当前确认人 */,
          key: this.lang == "zh" ? "approvalUserName" : "approvalUserEName",
          align: "center",
          minWidth: 120
        },
        {
          title: "绩效面谈总体评价" /* What评分 */,
          key: "interviewNotes",
          align: "center",
          minWidth: 120
        },
        {
          title: "What评分" /* What评分 */,
          key: "whatScore",
          align: "center",
          minWidth: 120
        },
        {
          title: "How评分" /* How评分 */,
          key: "howScore",
          align: "center",
          minWidth: 120
        },
        {
          title: "整体评分" /* 整体评分 */,
          key: "wholeScore",
          align: "center",
          minWidth: 120
        },
        {
          title: "员工确认绩效结果" /* 整体评分 */,
          key: "beKnowResult",
          align: "center",
          minWidth: 120
        },
        {
          title: "经理是否有做绩效面谈" /* 整体评分 */,
          key: "beManagerInterview",
          align: "center",
          minWidth: 120
        }
      ];
    },
    lang() {
      return this.$store.getters.selectLangeData;
    }
  },
  created() {
    this.searchItem.year = JSON.parse(sessionStorage.getItem("userInfo")).year;
  },
  mounted() {
    this.getData();
    this.getListData();
  },
  methods: {
    exportData() {
      let obj = {
        serialnumber: JSON.parse(sessionStorage.getItem("userInfo"))
          .serialnumber,
        ...this.searchItem,
        pageNo: 1,
        pageSize: 99999
      };
      this.loading = true;
      axios.post("/achReport/selectEmpInfo", obj).then(res => {
        if (res) {
          res.data.forEach(el => {
            el.updateStatusName = this.updateStatus
              .filter(item => el.updateStatusName == item.code)
              .map(res => (this.lang == "zh" ? res.ch_value : res.en_value))[0];
            el.status = this.ApplyStatus.filter(
              item => el.status == item.code
            ).map(res => (this.lang == "zh" ? res.ch_value : res.en_value))[0];
            el.businessUnit = this.businessUnitList
              .filter(item => el.businessUnit == item.code)
              .map(res => (this.lang == "zh" ? res.ch_value : res.en_value))[0];
            el.department = this.departmentList
              .filter(item => el.department == item.code)
              .map(res => (this.lang == "zh" ? res.ch_value : res.en_value))[0];
          });
          this.$nextTick(() => {
            this.$exportExcel(
              "tableRef",
              `${this.$t("Employee_Overview")}` +
                this.$nowDate.dateVal(new Date(), "YYYY-MM-DD HH-mm"),
              res.data
            ); /* '员工一览' */
          });
        }
        this.loading = false;
      });
    },
    getListData() {
      axios.post("/achReport/selectAchReportLabelInfo", {}).then(res => {
        if (res) {
          this.$refs.FormComponent.positionList = res.positionList;
          this.$refs.FormComponent.departmentList = res.departmentList;
          this.$refs.FormComponent.businessUnitList = res.businessUnitList;
          this.$refs.FormComponent.personnelType = res.personnelType;
          this.$refs.FormComponent.salesAreaList = res.salesAreaList;
          this.$refs.FormComponent.YesOrNo = res.YesOrNo;
          this.$refs.FormComponent.BeQuit = res.BeQuit;
          this.positionList = res.positionList;

          this.departmentList = res.departmentList;
          this.businessUnitList = res.businessUnitList;
          this.$refs.FormComponent.Level = res.Level;
          this.$refs.FormComponent.functionList = res.functionList;
          this.ApplyStatus = res.ApplyStatus;
          this.updateStatus = res.UpdateStatus;
          this.Level = res.Level;
          this.ManagementLevel = res.ManagementLevel;
        }
      });
    },
    getData(item) {
      item ? (this.searchItem = JSON.parse(item)) : "";
      let obj = {
        serialnumber: JSON.parse(sessionStorage.getItem("userInfo"))
          .serialnumber,
        ...this.searchItem,
        ...this.pageInfo
      };
      this.loading = true;
      axios.post("/achReport/selectEmpInfo", obj).then(res => {
        if (res) {
          this.data = res.data;
          this.total = parseInt(res.pageInfo.total);
        }
        this.$refs.FormComponent.prevent = false;
        this.loading = false;
      });
    },
    getFormData(item) {
      this.pageInfo.pageNo = 1;
      this.getData(item);
    },

    pageChange(val) {
      this.pageInfo.pageNo = val;
      this.getData(JSON.stringify(this.searchItem));
    },
    pageSizeChange(val) {
      this.pageInfo.pageSize = val;
      this.getData(JSON.stringify(this.searchItem));
    },
    checkBtn(row, index) {
      const href =
        "/01D12DA58A51C4D3259E1DE7BCAA10A6/A3FFBEBFDB713E27/?id=" +
        row.id +
        "&serialnumber=" +
        row.serialnumber +
        "&achStage=" +
        row.achStage +
        "&year=" +
        row.year +
        "&userName=" +
        row.userName +
        "&returnFlag='1'";
      window.open(href, "_blank");
      // this.$router.push({
      //   path: "/01D12DA58A51C4D3259E1DE7BCAA10A6/A3FFBEBFDB713E27",
      //   query: {
      //     id: row.id,
      //     serialnumber: row.serialnumber,
      //     achStage: row.achStage,
      //     year: row.year
      //   }
      // });
    },
    batchApproval() {
      // this.$refs.BatchApprovalModalComponent.modalShow=true
      this.$router.push(
        "/5BCC4A27AC412B7E84A39B5ED0BC758ABA610C6A6F738319/A3FFBEBFDB713E27"
      );
    },
    noSubmitEmp() {
      this.$refs.NoSubmitEmp.modalShow = true;
      this.$refs.NoSubmitEmp.searchItem.year = this.searchItem.year;
      this.$refs.NoSubmitEmp.searchItem.levelNum = this.searchItem.levelNum;
      this.$refs.NoSubmitEmp.getData();
    },
    handleReset() {
      this.formItem = {
        dirSupUserName: ""
      };
      // this.searchItem.year=this.date.dateVal(new Date(),'YYYY')
      // this.pageInfo.pageNo=1
      // this.getData(JSON.stringify(this.formItem))
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/process/performanceManagement/components/EmployeeList.vue